// src/components/Footer.jsx — Shop World Theme
import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const menuLinks = ['Pizza','Pasta','Shakes','Burger','Take & Bake'];
  const aboutLinks = [['Our Story','#'],['Our Locations','#'],['Current Deals','#'],['Contact Us','#'],['Privacy Policy','/PrivacyPolicy']];
  const locLinks = ['Shop World Delhi','Shop World Mumbai','Shop World Chennai','Shop World Bangalore'];

  return (
    <footer style={{ fontFamily:"'Poppins',sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=Poppins:wght@400;600;700;800&display=swap');
        .footer-link { display:block; font-size:13px; color:rgba(255,255,255,0.55); margin-bottom:10px; text-decoration:none; font-weight:600; transition:color 0.2s; }
        .footer-link:hover { color:#fff; }
        .footer-social { width:36px; height:36px; border-radius:50%; background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.14); color:rgba(255,255,255,0.5); cursor:pointer; font-size:13px; font-weight:800; display:flex; align-items:center; justify-content:center; transition:all 0.2s; text-decoration:none; }
        .footer-social:hover { background:#E63946; border-color:#E63946; color:#fff; }
        @media(max-width:768px) { .footer-grid { grid-template-columns:1fr 1fr!important; gap:28px!important; } .footer-brand { grid-column:1/-1; } }
        @media(max-width:480px) { .footer-grid { grid-template-columns:1fr!important; } }
      `}</style>

      {/* Discount / newsletter banner */}
      <div style={{ background:'#E63946', padding:'clamp(28px,5vw,40px) clamp(16px,4vw,24px)', textAlign:'center' }}>
        <div style={{ maxWidth:660, margin:'0 auto' }}>
          <p style={{ fontSize:11, fontWeight:800, letterSpacing:'0.2em', textTransform:'uppercase', color:'rgba(255,255,255,0.75)', marginBottom:10 }}>SHOP WORLD</p>
          <h2 style={{ fontFamily:"'Poppins, sans-serif", fontSize:'clamp(1.6rem,3.5vw,2.4rem)', fontWeight:400, color:'#fff', margin:'0 0 10px', lineHeight:1.2 }}>Get Started Today!</h2>
          <p style={{ color:'rgba(255,255,255,0.82)', fontSize:14, fontWeight:600, marginBottom:6, maxWidth:480, margin:'0 auto 8px' }}>Everything you need to build an amazing food restaurant responsive website.</p>
          <p style={{ color:'rgba(255,255,255,0.65)', fontSize:12, fontWeight:400, lineHeight:1.7, maxWidth:520, margin:'0 auto 28px' }}>We prepare delicious Food for you we are always ready — fresh, healthy, delivered fast right to your door.</p>
          <form onSubmit={e=>e.preventDefault()} style={{ display:'flex', maxWidth:440, margin:'0 auto', gap:0, flexWrap:'wrap' }}>
            <input type="email" placeholder="Enter your email address..." style={{ flex:1, padding:'13px 20px', borderRadius:'8px 0 0 8px', border:'none', fontSize:13, outline:'none', fontFamily:"'Poppins',sans-serif", background:'rgba(255,255,255,0.95)', color:'#1A1A2E' }} />
            <button type="submit" style={{ padding:'13px 24px', background:'#1A1A2E', color:'#fff', border:'none', borderRadius:'0 8px 8px 0', fontSize:13, fontWeight:800, cursor:'pointer', fontFamily:"'Poppins',sans-serif", whiteSpace:'nowrap' }}>Subscribe</button>
          </form>
        </div>
      </div>

      {/* App download bar */}
      <div style={{ background:'#222', padding:'clamp(14px,3vw,20px) clamp(16px,4vw,24px)' }}>
        <div style={{ maxWidth:1280, margin:'0 auto', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12 }}>
          <div>
            <p style={{ fontSize:11, fontWeight:800, letterSpacing:'0.16em', textTransform:'uppercase', color:'#E63946', margin:'0 0 4px' }}>Get 20% Discount</p>
            <p style={{ fontSize:13, color:'rgba(255,255,255,0.7)', fontWeight:600, margin:0 }}>
              Get flat 20% off on your first order through <span style={{ color:'#fff', fontWeight:800 }}>The Shop World App!</span>
            </p>
          </div>
          <div style={{ display:'flex', gap:10 }}>
            {[{icon:'▶', label:'Google Play'},{icon:'🍎', label:'App Store'}].map(a => (
              <a key={a.label} href="#" style={{ display:'flex', alignItems:'center', gap:8, padding:'10px 18px', background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.18)', borderRadius:10, textDecoration:'none', transition:'all 0.2s' }}
                onMouseEnter={e=>e.currentTarget.style.background='rgba(230,57,70,0.3)'}
                onMouseLeave={e=>e.currentTarget.style.background='rgba(255,255,255,0.08)'}>
                <span style={{ fontSize:18 }}>{a.icon}</span>
                <div style={{ textAlign:'left' }}>
                  <div style={{ fontSize:9, color:'rgba(255,255,255,0.55)', fontWeight:600, letterSpacing:'0.06em', textTransform:'uppercase' }}>Download on</div>
                  <div style={{ fontSize:13, color:'#fff', fontWeight:800 }}>{a.label}</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div style={{ background:'#1A1A2E', padding:'clamp(36px,6vw,56px) clamp(16px,4vw,24px) clamp(24px,4vw,36px)' }}>
        <div className="footer-grid" style={{ maxWidth:1280, margin:'0 auto', display:'grid', gridTemplateColumns:'1.5fr 1fr 1fr 1fr', gap:48 }}>

          {/* Brand */}
          <div className="footer-brand">
            <Link to="/" style={{ display:'flex', alignItems:'center', gap:9, textDecoration:'none', marginBottom:18 }}>
              <div style={{ width:40, height:40, borderRadius:'50%', background:'#E63946', display:'flex', alignItems:'center', justifyContent:'center', fontSize:22 }}>🛍</div>
              <span style={{ fontFamily:"'Poppins, sans-serif", fontSize:22, color:'#fff' }}>Shop<span style={{color:'#E63946'}}>World</span></span>
            </Link>
            <p style={{ color:'rgba(255,255,255,0.5)', fontSize:13, lineHeight:1.85, marginBottom:24, fontWeight:400 }}>
              Delivering the finest shopping experience right to your doorstep. Fresh deals, fast delivery, always the best prices.
            </p>
            <div style={{ display:'flex', gap:10 }}>
              {['G','f','in'].map(s => (
                <a key={s} href="#" className="footer-social">{s}</a>
              ))}
            </div>
          </div>

          {/* About */}
          <div>
            <h5 style={{ fontSize:12, fontWeight:800, letterSpacing:'0.16em', textTransform:'uppercase', color:'#E63946', marginBottom:20, margin:'0 0 20px' }}>ABOUT US</h5>
            {aboutLinks.map(([l,to]) => <a key={l} href={to} className="footer-link">{l}</a>)}
          </div>

          {/* Menu */}
          <div>
            <h5 style={{ fontSize:12, fontWeight:800, letterSpacing:'0.16em', textTransform:'uppercase', color:'#E63946', marginBottom:20, margin:'0 0 20px' }}>OUR MENU</h5>
            {menuLinks.map(l => <Link key={l} to={`/shop?search=${l}`} className="footer-link">{l}</Link>)}
          </div>

          {/* Location */}
          <div>
            <h5 style={{ fontSize:12, fontWeight:800, letterSpacing:'0.16em', textTransform:'uppercase', color:'#E63946', marginBottom:20, margin:'0 0 20px' }}>OUR LOCATION</h5>
            {locLinks.map(l => <a key={l} href="#" className="footer-link">{l}</a>)}
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ maxWidth:1280, margin:'28px auto 0', paddingTop:20, borderTop:'1px solid rgba(255,255,255,0.08)', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:10 }}>
          <p style={{ color:'rgba(255,255,255,0.3)', fontSize:12 }}>© 2024 The Foody. All rights reserved.</p>
          <p style={{ color:'rgba(255,255,255,0.3)', fontSize:12 }}>Powered by The FOODY</p>
        </div>
      </div>
    </footer>
  );
}
